<template>
  <div class="nav-wraper" :class="`nav-wraper--${createRenderType}`">
    <div class="height-all nav-box">
      <div class="nav-wraper-main">
        <template v-for="(item, index) in getNavs()" :key="item.routername">
          <div
            class="nav-item tl pointer"
            v-if="item.routername != 'speech' || createRenderType != 'mobile'"
            :class="{
              active:
                item.routername == matchHighLight ||
                (item.routername == 'create' &&
                  ['create', 'editor', 'instrumental'].includes(matchHighLight)),
              'nav-item--mobile-hidden': !item.mobileVisible,
            }"
            @click="
              () => {
                goRouter(item, 'default')
              }
            "
          >
            <div class="nav-item-level-1">
              <i class="fn-inline high-line"></i>
              <i
                class="fn-inline ico"
                :style="{
                  background:
                    item.routername == matchHighLight ||
                    (item.routername == 'create' &&
                      ['create', 'editor', 'instrumental'].includes(matchHighLight))
                      ? `url(${item.highIco})`
                      : `url(${item.ico})`,
                  backgroundSize: '100% 100%',
                }"
              ></i>
              <span class="fn-inline text olh">{{ item.label }}</span>
              <div
                class="countdown"
                v-if="item.routername == 'subscribe' && userDataStore.countdown > 0"
              >
                <div class="time">
                  <img src="@/assets/img/home/icon-clock.png" alt="" /><span>{{
                    formatCountdown(userDataStore.countdown)
                  }}</span>
                </div>
                <div class="tip">
                  <span>{{ userDataStore.userInfo?.discount?.discount_percent ?? "" }}%</span>
                  {{ $t("credit.off") }}!!!
                </div>
              </div>
            </div>
            <div
              v-if="item.routername == 'create'"
              class="nav-item-level-2-box sub-item nav-item--mobile-hidden"
              :class="{ active: isHeightLight() }"
            >
              <template v-for="(item, num) in createSubNavs()" :key="num">
                <div
                  class="nav-item-level-2 sub-item-content"
                  v-if="item.opend"
                  :class="{
                    active: item.routername == matchHighLight,
                  }"
                  @click.stop="
                    () => {
                      goRouter(item, 'sub')
                    }
                  "
                >
                  <i></i>
                  <span class="olh">{{ item.label }}</span>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
      <div class="user-nav-list">
        <div class="recover" @click="goRecover" v-if="GlobalConfig.appname === 'MurekaCn'">
          <div class="recover-btn">
            <span class="recover-btn-text">账号找回和迁移</span>
            <span class="recover-btn-arrow">›</span>
          </div>
        </div>
        <div class="user-nav-box">
          <div class="user-nav-item flex pointer" @click="handleCredits">
            {{ `${$t("credit.credits")}: ${userDataStore?.credits || 0}` }}
          </div>
          <div
            class="user-nav-item flex pointer"
            v-for="item in userNavs.navs"
            :key="item.name"
            @click="handleUserNavClick(item)"
          >
            {{ item.label }}
            <span class="red-dot" v-if="item.name === 'news' && !homeDataStore.newsReaded"></span>
            <img v-if="item.img" :src="item.img" alt="" />
          </div>
          <div v-if="renderData.ifRenderLangPopover && globalConfig.appname !== chinaAppName">
            <el-popover
              placement="right"
              popper-class="more-language-list-box"
              trigger="hover"
              :popper-options="{
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, 1],
                    },
                  },
                ],
              }"
            >
              <template #reference>
                <div class="user-nav-item flex pointer" @click.stop>
                  {{
                    $t("common.cur_language", {
                      lang: $t("common.current_language"),
                    })
                  }}
                </div>
              </template>
              <div class="more-language-list">
                <template v-for="(item, index) in LanguageList" :key="item.key">
                  <div
                    class="more-language-item flex"
                    :class="{
                      active: $$language() === item.key,
                    }"
                    @click="
                      () => {
                        handleLanguageChange(item)
                      }
                    "
                  >
                    <span class="block flex1 width-0">{{ item.label }}</span>
                    <i class="block"></i>
                  </div>
                </template>
              </div>
            </el-popover>
          </div>
        </div>
        <div class="avatar pointer">
          <div class="pc" v-if="userDataStore.isLogin">
            <el-dropdown
              v-if="renderData.ifRenderLangPopover"
              ref="refElDropdown"
              placement="top"
              popper-class="header-drop"
              trigger="click"
              @command="handleCommand"
            >
              <div class="el-dropdown-link">
                <img
                  v-if="userDataStore?.userInfo?.user?.profile_image"
                  :src="getObjectStorageFullUrl(userDataStore?.userInfo?.user?.profile_image)"
                  alt="header"
                />
                <div>
                  <div class="username">
                    {{ userDataStore?.userInfo?.user?.stage_name }}
                  </div>
                </div>
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="edit">{{ $$t("mine.Editprofile") }}</el-dropdown-item>
                  <el-dropdown-item command="terms">{{
                    $t("mine.TermsofService")
                  }}</el-dropdown-item>
                  <el-dropdown-item command="privacy">{{
                    $t("mine.PrivacyPolicy")
                  }}</el-dropdown-item>
                  <el-dropdown-item command="research">{{ $$t("mine.Research") }}</el-dropdown-item>
                  <el-dropdown-item command="about">{{ $t("mine.about_mureka") }}</el-dropdown-item>
                  <el-dropdown-item :style="{ color: '#FF5745' }" command="delete">{{
                    $t("mine.Deleteaccount")
                  }}</el-dropdown-item>
                  <el-dropdown-item command="logout">{{ $t("mine.Logout") }}</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          <div class="unlogin" v-if="!userDataStore.isLogin" @click="showLogin">
            <!-- <img src="@/assets/img/login_false.png" alt="" />
            <div class="unlogin-text">Sign in</div> -->
            {{ $t("mine.try_free_now") }}
          </div>
        </div>
      </div>
    </div>
    <WhatsNew
      v-if="dialogStore.whatsNewDialog"
      @close="handleUserDialogClose"
      @doRetry="doNewsRetry"
    />
  </div>
</template>

<script setup>
import {
  defineProps,
  defineEmits,
  computed,
  reactive,
  watch,
  defineExpose,
  onMounted,
  getCurrentInstance,
  ref,
} from "vue"
import { LanguageList } from "@/i18n/i18n.js"
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js"

import globalConfig, { ModuleOpenStateControl, chinaAppName } from "@/config/config.js"

import { storeToRefs } from "pinia"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
const createLayoutStore = useCreateLayoutStore()
const { createRenderType, lastCreateTabName } = storeToRefs(createLayoutStore)
import useHomeDataStore from "@/store/homeDataStore.js"
import useCreditDataStore from "@/store/credit/creditDataStore.js"
import useDialogStore from "@/store/dialogStore.js"

import { useRouter, useRoute } from "vue-router"

import homeIco from "@/assets/img/home-ico.png"
import homeHighIco from "@/assets/img/home-high-ico.png"

import createIco from "@/assets/img/create-ico.png"
import createHighIco from "@/assets/img/create-high-ico.png"

import ttsIco from "@/assets/img/tts/icon-tts.png"
import ttsHighIco from "@/assets/img/tts/icon-tts-light.png"

import creditsIco from "@/assets/img/credits-ico.png"
import creditsHighIco from "@/assets/img/credits-high-ico.png"

import libraryIco from "@/assets/img/library-ico.png"
import libraryHighIco from "@/assets/img/library-high-ico.png"
import useUserDataStore from "@/store/userDataStore.js"
import { isDev, isProd } from "@/utils/tools.js"
import apiUser from "@/api/api/apiUser.js"
import { funComponentList } from "@/components/functionComp/index"

import { showActionDialog } from "@/components/functionCallComponent/action/action.js"
import WhatsNew from "./dialogs/whatsNew.vue"

import ShowInviteDialog from "@/components/inviteDialog/inviteDialog.js"
import giftImg from "@/assets/img/gift.png"
import message from "@/components/functionCallComponent/message/message.js"
import ShowFeedbackDialog from "@/components/feedbackDialog/feedbackDialog.js"

import GlobalConfig from "@/config/config.js"

const Router = useRouter()
const route = useRoute()
const userDataStore = useUserDataStore()
const homeDataStore = useHomeDataStore()
const creditDataStore = useCreditDataStore()
const dialogStore = useDialogStore()

const globalProperties = getCurrentInstance()?.appContext.config.globalProperties
const { $$t, $$language, $$tValue } = globalProperties?.$i18n ?? {}

const matchHighLight = computed(() => {
  return route?.meta?.title ?? ""
})

const refElDropdown = ref(null)

const props = defineProps({})
const emits = defineEmits([])
const getNavs = () => {
  return [
    {
      label: $$t("common.nav_home"),
      routername: "home",
      ico: homeIco,
      highIco: homeHighIco,
      mobileVisible: true,
      code: 0,
    },
    {
      label:
        createRenderType.value == "mobile"
          ? $$t("common.nav_create")
          : $$t("common.nav_create_music"),
      routername: "create",
      ico: createIco,
      highIco: createHighIco,
      mobileVisible: true,
      code: 1,
    },
    {
      label: $$t("tts.create_audio"),
      routername: "speech",
      ico: ttsIco,
      highIco: ttsHighIco,
      mobileVisible: true,
      code: 2,
    },
    {
      label: $$t("common.nav_library"),
      routername: "library",
      ico: libraryIco,
      highIco: libraryHighIco,
      mobileVisible: true,
      code: 3,
    },
    {
      label: $$t("common.nav_credits"),
      routername: "subscribe",
      ico: creditsIco,
      highIco: creditsHighIco,
      mobileVisible: true,
      code: 4,
    },
  ]
}

const createSubNavs = () => {
  return [
    {
      label: $$t("common.generation"),
      routername: "create",
      tab_stare: "generation",
      sub: true,
      opend: true,
    },
    {
      label: $$t("common.bgm"),
      routername: "instrumental",
      tab_stare: "instrumental",
      sub: true,
      opend: true,
    },
    {
      label: $$t("common.audio_edit"),
      routername: "editor",
      tab_stare: "audio_edit",
      sub: true,
      opend: ModuleOpenStateControl.editor.opened,
    },
  ]
}

const getSecNavList = () => {
  return [
    {
      label: $$t("mine.invite_for_free_credits"),
      name: "invite",
      img: giftImg,
    },
    {
      label: $$t("mine.API_Platform"),
      name: "api",
    },
    // {
    //   label: $$t("mine.Research"),
    //   name: "research",
    // },
    ...(globalConfig.appname !== "MurekaCn"
      ? [
          {
            label: $$t("mine.what_new"),
            name: "news",
          },
        ]
      : []),
    ...(ModuleOpenStateControl.speControl.feedback
      ? [
          {
            label: $$t("editor.feedback"),
            name: "feedback",
          },
        ]
      : []),
  ]
}

const goRecover = () => {
  window.open("https://platform.mureka.ai/recoveraccount", "_blank")
}

const isHeightLight = () => {
  const heightLightNavs = ["create", "instrumental", "editor", "createIndex"]
  const path = Router.currentRoute.value.name
  if (heightLightNavs.includes(path)) {
    return true
  }
  return false
}

const userNavs = reactive({
  navs: getSecNavList(),
})

const userActiveNav = ref("")

const renderData = reactive({
  curnav: "",
  ifRenderLangPopover: true,
})

const truncatedEmail = (email) => {
  if (!email) return ""
  const [localPart, domainPart] = email.split("@")
  const localFormatted = localPart.length > 10 ? localPart.slice(0, 10) + "..." : localPart
  const domainFormatted =
    domainPart && domainPart.length > 10 ? domainPart.slice(0, 10) + "..." : domainPart
  return domainFormatted ? `${localFormatted}@${domainFormatted}` : localFormatted
}

const gorouter = async (item, type) => {
  if (item.routername == "library" || item.routername == "subscribe") {
    if (
      !(await userDataStore.checkLoginStatus({
        source: item.routername,
      }))
    ) {
      return
    }
    if (item.routername == "subscribe") {
      Router.push({
        name: item.routername,
        query: {
          membership_source1: "subcribe_tab",
        },
      })
      return
    }
  }
  if (item.routername == "create" && type == "default") {
    Router.push({ name: lastCreateTabName.value })
    return
  }
  if (type == "sub") {
    lastCreateTabName.value = item.routername
  }
  Router.push({ name: item.routername })
}

const goRouter = (item, type) => {
  renderData.curnav = item.routername
  gorouter(item, type)
  if (item.sub) {
    globalProperties.logClickEvent("create_tab_stare", {
      tab_stare: item.tab_stare,
    })
    return
  }
  globalProperties.logClickEvent("navigation", {
    nav_code: item.code,
    tab_stare: item.routername,
  })
}

const handleCredits = () => {
  Router.push({
    name: "subscribe",
  })
  creditDataStore.changeCreditSialogDate(true)
}

const showLogin = () => {
  userDataStore.checkLoginStatus({})
}

const handleCommand = (command) => {
  switch (command) {
    case "edit":
      console.log(`click on item ${command}`)
      funComponentList.EditUserInfo({
        handleOk: (str) => {},
      })
      break
    case "logout":
      logOutApi()
      break
    case "order":
      Router.push({
        name: "order",
      })
      break
    case "earnings":
      Router.push({
        name: "sald",
      })
      break
    case "delete":
      deleteAccount()
      break
    case "terms":
      window.open(
        globalConfig.appname == "MurekaCn"
          ? import.meta.env.VITE_API_URL + "/static/terms-cn-20250829.pdf"
          : import.meta.env.VITE_API_URL + "/static/terms-20250709.pdf",
        "_blank"
      )
      break
    case "research":
      globalProperties.logClickEvent("research")
      const research = `https://${isDev() ? "platform-test" : "platform"}.mureka.${
        globalConfig.appname == chinaAppName ? "cn" : "ai"
      }/docs/${globalConfig.appname == chinaAppName ? "cn" : "en"}/ai-music-o1-moment.html`
      window.open(research, "_blank")
      break
    case "privacy":
      window.open(
        globalConfig.appname == "MurekaCn"
          ? import.meta.env.VITE_API_URL + "/static/privacy.pdf"
          : import.meta.env.VITE_API_URL + "/static/privacy-20250709.pdf",
        "_blank"
      )
      break
    case "about":
      globalProperties.logClickEvent("catalog_about_mureka")
      Router.push({
        name: "about",
      })
      break
    case "switchLanguage":
      break
    default:
      console.log(`Unknown command: ${command}`)
  }
}
const refPopover = ref(null)
const handleLanguageChange = (val) => {
  renderData.ifRenderLangPopover = false
  nextTick(() => {
    // refElDropdown.value?.handleClose();
    renderData.ifRenderLangPopover = true
    nextTick(() => {
      userDataStore.switchLanguage(val.key)
    })
  })
}

const handleUserNavClick = async (item) => {
  // 如果是news，设置已读
  switch (item.name) {
    case "invite":
      globalProperties.logClickEvent("invite_for_free_credits")
      if (!(await userDataStore.checkLoginStatus())) {
        return
      }
      ShowInviteDialog()
      break
    case "news":
      globalProperties.logClickEvent("what_is_new")
      dialogStore.openWhatsNewsDialog()
      homeDataStore.changeNewReaded(true)
      break
    case "faq":
      Router.push({
        name: "faq",
      })
      break
    case "about":
      globalProperties.logClickEvent("catalog_about_mureka")
      Router.push({
        name: "about",
      })
      break
    case "feedback":
      globalProperties.logClickEvent("feedback_global")
      ShowFeedbackDialog()
      break
    case "api":
      globalProperties.logClickEvent("api_platform")
      const url = `https://${isDev() ? "platform-test" : "platform"}.mureka.${
        globalConfig.appname == chinaAppName ? "cn" : "ai"
      }`
      window.open(url, "_blank")
      break
    case "research":
      globalProperties.logClickEvent("research")
      const research = `https://${isDev() ? "platform-test" : "platform"}.mureka.${
        globalConfig.appname == chinaAppName ? "cn" : "ai"
      }/docs/${globalConfig.appname == chinaAppName ? "cn" : "en"}/ai-music-o1-moment.html`
      window.open(research, "_blank")
      break
    default:
      console.log(`Unknown command: ${item}`)
  }
  userActiveNav.value = item.name
}

const handleUserDialogClose = () => {
  dialogStore.closeWhatsNewsDialog()
  dialogStore.getPopupShow()
  // homeDataStore.changeNewsShow(false);
}

const deleteAccount = async () => {
  showActionDialog({
    content: $$t("mine.deleteyouraccount"),
    cancelLabel: $$t("mine.Cancel"),
    confirmLabel: $$t("mine.Deleteaccount"),
    confirm: (closeAction) => {
      closeAction()
      deleteApi()
    },
    cancel(closeAction) {
      closeAction()
    },
  })
}

const deleteApi = async () => {
  const { data, code, msg } = await apiUser.deleteAccount({})
  if (code == 200) {
    userDataStore.clearAll()
    Router.push({
      name: "home",
    })
  } else {
    message.error({
      maskClosable: true,
      position: "top",
      content: msg,
    })
  }
}

const logOutApi = async () => {
  const { data, code, msg } = await apiUser.userLoginOut({}, userDataStore?.userInfo?.user?.user_id)
  if (code == 200) {
    userDataStore.clearAll()
    Router.push({
      name: "home",
    })
    // window.location.reload()
  } else {
    message.error({
      maskClosable: true,
      position: "top",
      content: msg,
    })
  }
}

const formatCountdown = (seconds) => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  return [
    hours.toString().padStart(2, "0"),
    minutes.toString().padStart(2, "0"),
    secs.toString().padStart(2, "0"),
  ].join(":")
}

watch(
  () => route.name,
  (newVal, oldVal) => {
    renderData.curnav = newVal
  }
)

const doNewsRetry = () => {
  homeDataStore.doNewsRetry()
}

watch(
  () => userDataStore.appLanguage,
  (newVal) => {
    nextTick().then(() => {
      userNavs.navs = getSecNavList()
      homeDataStore.doNewsRetry()
    })
  }
)

onMounted(() => {
  renderData.curnav = route.name
  homeDataStore.doNewsRetry()
})
</script>
<style lang="scss" scoped>
.nav-wraper {
  height: 100%;
  padding: 12px 0 0 0;
  .nav-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .user-nav-list {
    color: #fff;
    .recover {
      padding: 0 16px 16px 16px;
      .recover-btn {
        width: 100%;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 20px;
        color: #fff;
        font-size: 15px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 9px 16px;
        cursor: pointer;
        transition: 0.2s;
        outline: none;
        &:hover {
          background: rgba(255, 255, 255, 0.15);
        }
        .recover-btn-text {
          flex: 1;
          text-align: left;
        }
        .recover-btn-arrow {
          font-size: 18px;
          margin-left: 8px;
          color: #fff;
        }
      }
    }
    .user-nav-box {
      padding-left: 16px;
      margin-bottom: 20px;
      .user-nav-item {
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        margin-bottom: 6px;
        opacity: 0.8;
        align-items: center;
        color: rgba(255, 255, 255, 0.5);
        img {
          width: 16px;
          height: 16px;
          margin-left: 5px;
        }

        &:last-child {
          margin-bottom: 0;
        }
        .red-dot {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #ff5f74;
          transform: translate(5px, -5px);
        }
      }
      .pointer {
        &:hover {
          opacity: 1;
        }
      }
    }
  }
  .nav-item {
    .countdown {
      color: #fff;
      position: relative;
      background: linear-gradient(91deg, #4fdeff -40%, #d9f8ff 52%, #e675ff 132%);
      height: 24px;
      width: fit-content;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 2px 4px 2px 2px;
      gap: 4px;
      border-radius: 6px;
      margin-left: 18px;
      &::after {
        content: "";
        position: absolute;
        top: -4px;
        left: 14px;
        background-image: url("@/assets/img/home/icon-cycle.png");
        background-size: 100% 100%;
        width: 8px;
        height: 4px;
      }
      .time {
        display: flex;
        align-items: center;
        background: #000000;
        padding: 3px 5px;
        gap: 4px;
        border-radius: 4px;
        img {
          width: 10px;
          height: 10px;
        }
        span {
          padding-top: 2px;
          background: linear-gradient(108deg, #ffe08b 0%, #fff7d0 47%, #ffe08b 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
          font-size: 10px;
          font-weight: bold;
          line-height: 12px;
        }
      }
      .tip {
        font-size: 10px;
        font-weight: 900;
        line-height: 18px;
        color: #000000;
        span {
          color: #ff5f74;
          display: inline-block;
        }
      }
    }
    .nav-item-level-1 {
      line-height: 44px;
      min-height: 44px;
    }

    // margin: 0 0 12px 0;
    i.high-line {
      width: 4px;
      height: 18px;
      opacity: 0;
      background: rgba(148, 173, 255, 1);
    }
    i.ico {
      margin-left: 20px;
      width: 24px;
      height: 24px;
      opacity: 5;
    }
    .text {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.04em;
      color: rgba(255, 255, 255, 0.5);
      margin-left: 8px;
      width: calc(100% - 56px);
    }
    .sub-item {
      display: flex;
      flex-direction: column;
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.1s ease-out;
      .sub-item-content {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: left;
        padding-left: 57px;
        color: rgba(255, 255, 255, 0.5);
        margin-bottom: 8px;
        &:last-child {
          margin-bottom: 0;
        }
        i {
          display: block;
          width: 4px;
          height: 4px;
          background-color: rgba(255, 255, 255, 0.5);
          border-radius: 4px;
          margin-right: 10px;
        }
        span {
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          flex: 0 1 auto;
        }
        &:hover {
          color: rgba(255, 255, 255, 0.8);
          i {
            background-color: rgba(255, 255, 255, 0.8);
          }
        }
        &.active {
          color: #94adff;
          i {
            background-color: #94adff;
          }
        }
      }
      &.active {
        max-height: 100px;
      }
    }
  }
  .nav-item:hover {
    .text {
      color: rgba(255, 255, 255, 1);
    }
  }
  .nav-item.active {
    transition: unset;
    i.high-line {
      opacity: 1;
    }
    i.ico {
      opacity: 1;
    }
    .text {
      color: rgba(148, 173, 255, 1);
      font-weight: bold;
    }
  }
  &.nav-wraper--mobile {
    padding: 0 16px;
    position: relative;
    .nav-wraper-main {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
    }

    // background: #05102f;
    .nav-item {
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: max-content;
      padding: 0 10px;
      justify-content: center;
      .nav-item-level-1 {
        line-height: 52px;
        min-height: 52px;
      }
      i.high-line {
        display: none;
      }
      i.ico {
        display: none;
        margin: 0 auto;
        line-height: 20px;
        height: 20px;
        width: 20px;
      }
      .text {
        color: rgba(255, 255, 255, 0.5);
        line-height: 24px;
        margin: 0;
        font-size: 16px;
        width: max-content;
      }
    }
    .nav-item--mobile-hidden {
      display: none;
    }
    .nav-item:hover {
      .text {
        color: rgba(255, 255, 255, 1);
      }
    }
    .nav-item.active {
      .text {
        color: rgba(148, 173, 255, 1);
        font-weight: bold;
      }
    }
  }
  .avatar {
    margin: 0 16px 20px;
    display: flex;
    align-items: center;
    background: #ffffff33;
    border-radius: 60px;
    overflow: hidden;
    .pc {
      width: 100%;
      padding: 7px 10px;
    }
    .unlogin {
      // width: 100%;
      // height: 100%;
      // display: flex;
      // align-items: center;
      // flex-direction: row;
      // .unlogin-text {
      //   margin-left: 8px;
      // }
      // img {
      //   border-radius: 50%;
      //   width: 28px;
      //   height: 28px;
      //   min-width: 28px;
      //   border: none;
      //   display: block;
      // }
      text-align: center;
      width: 100%;
      height: 44px;
      font-size: 16px;
      font-weight: 900;
      background: linear-gradient(106deg, #1a3c8d 5%, #695bc5 47%, #3a1b6f 100%);
      border-radius: 50px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    :deep(.el-dropdown) {
      width: 100%;
      .el-dropdown-link {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        img {
          border-radius: 50%;
          width: 28px;
          height: 28px;
          min-width: 28px;
          border: none;
          display: block;
        }
        .username {
          color: #fff;
          margin-left: 7px;
          flex-grow: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 16px;
          font-weight: 500;
          line-height: 20px;
        }
        .email {
          margin-left: 7px;
          font-size: 10px;
          line-height: 14px;
          color: rgba(255, 255, 255, 0.5);
        }
      }
    }
    &:hover {
      opacity: 0.8;
    }

    .mobile {
      display: none;
    }
  }
  @media (max-width: 768px) {
    .avatar {
      display: none;
    }
    .user-nav-list {
      display: none;
    }
  }
}
</style>
<style lang="scss">
.header-drop {
  .el-dropdown-menu {
    background: #3e3450;
    .el-dropdown-menu__item {
      color: #fff;
      padding: 8px 20px;
      font-weight: 400;
      &.switch-language-drop-item {
        padding: 0;
        .switch-language {
          padding: 8px 20px;
          width: 100%;
        }
      }
    }
  }
}
.el-popover.el-popper.more-language-list-box {
  background: #3e3450;
  border: none;
  font-weight: bold;
  border-radius: 8px;
  padding: 0;
  overflow: hidden;
  .el-popper__arrow {
    display: none;
  }
  .more-language-list {
    min-width: max-content;
    .more-language-item {
      align-items: center;
      color: #fff;
      cursor: pointer;
      display: flex;
      font-size: 14px;
      line-height: 38px;
      list-style: none;
      padding: 0 16px;
      white-space: nowrap;
      justify-content: space-between;
      i {
        height: 20px;
        width: 20px;
        background-image: url(@/assets/img/check-blue-ico.png);
        background-size: 100% 100%;
        opacity: 0;
        margin-left: 16px;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.1);
        color: #fff;
      }
      &.active {
        color: #94adff;
        i {
          opacity: 1;
        }
        &:hover {
          background: rgba(255, 255, 255, 0.1);
        }
      }
    }
  }
  .el-popper__arrow:before {
    background: #3e3450;
    border: 1px solid #3e3450;
  }
}
</style>
